import {
  WidgetInstance,
} from 'mobx-store/stores/customScreens/types';
import { ValidationOptionsKeys } from 'screens/addEditCustomScreen/types';
import { ValidationSchema } from '../validation.helper';

export interface Props {
  focusedWidgetData: WidgetInstance;
  focusedWidget: null | string | number;
  handleChangeData: (paramName: string, value: string) => void;
  removeFocusedWidget: () => void;
  handleMultipleChangeData: (params: {}) => void;
}

export enum IconWidgetType {
  INTERNAL='internal',
  EXTERNAL='external',
  NATIVE='NATIVE'
}



export const iconWidgetValidation: ValidationSchema =  {
  title: [{ validation: [ValidationOptionsKeys.REQUIRED],}],
  imageURL: [{ validation: [ValidationOptionsKeys.REQUIRED],}],
  textColor: [{ validation: [ValidationOptionsKeys.REQUIRED],}],
  isButton: [],
  buttonText:  [{
    validation: [ValidationOptionsKeys.REQUIRED],
    case: {
      key: 'isButton',
      value: 'true'
    }
   }],
  cardActionType: [{
          validation: [ValidationOptionsKeys.REQUIRED],    
  }],
  cardActionExternalLink: [{
    validation: [ValidationOptionsKeys.REQUIRED],
    case: {
      key: 'cardActionType',
      value: IconWidgetType.EXTERNAL
    }
  }],
  cardActionParams: [],
  cardActionRedirect: [{
      validation: [ValidationOptionsKeys.REQUIRED],
      case: {
        key: 'cardActionType',
        value: IconWidgetType.INTERNAL
      }
  }],
  cardActionEntityId: [],

}